let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1AwT5")).then(() => parcelRequire('lFUQq'));